// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"b0b96233","209":"d464d894","478":"8716c79d","805":"7194412c","872":"f763e0ca","874":"d52b42a5","922":"fefd4601"}[chunkId] + ".chunk.js";
};